import Constants from "../constants/index";

/**
 * Checks whether the given role is a Driver or Helper role.
 *
 * @param {string} role - The role to check.
 * @returns {{ isDriverRole: boolean, isHelperRole: boolean }} 
 * An object containing two boolean values:
 * - `isDriverRole`: True if the role matches the Driver role.
 * - `isHelperRole`: True if the role matches the Helper role.
 */
export const checkDriverORhelperRole = (role: string) => {
  const isDriverRole = role === Constants.USERS_CONSTANTS.DRIVER_ROLE;
  const isHelperRole = role === Constants.USERS_CONSTANTS.HELPER_ROLE;

  return { isDriverRole, isHelperRole };
};
